import {
  call, put, takeEvery, takeLatest
} from 'redux-saga/effects';
import costFileTemplateApi from '../../externals/costFileTemplateProxy';
import {
  UNABLE_TO_LOAD_COST_FILE_TEMPLATE,
  UNABLE_TO_SAVE_COST_FILE_TEMPLATE,
  UNABLE_TO_DELETE_COST_FILE_TEMPLATE,
} from '../../helpers/messageConstant';
import {
  FETCH_COST_FILE_TEMPLATE,
  SAVE_COST_FILE_TEMPLATE,
  DELETE_COST_FILE_TEMPLATE,
  receiveCostFileTemplate,
  receiveCostFileTemplateSaveStatus,
  receiveCostFileTemplateDeleteStatus,
} from '../actions/costFileTemplateActions';
import { receiveErrorInCostFileTemplate } from '../actions/errorDialogActions';

const getErrorMessage = (e, fallback) => {
  const message = e?.response?.data;
  return typeof message === 'string' && message ? message : fallback;
};

export function* fetchCostFileTemplate({ data }) {
  const { suvc } = data;
  try {
    const response = yield call(costFileTemplateApi.getTemplate, suvc);
    yield put(receiveCostFileTemplate(suvc, response));
  } catch (e) {
    yield put(receiveErrorInCostFileTemplate(getErrorMessage(e, UNABLE_TO_LOAD_COST_FILE_TEMPLATE)));
  }
}

export function* saveCostFileTemplate({ data }) {
  const {
    suvc, templateId, templateName, columns
  } = data;
  try {
    const response = templateId
      ? yield call(costFileTemplateApi.updateTemplate, { templateId, templateName, columns })
      : yield call(costFileTemplateApi.createTemplate, { suvc, templateName, columns });
    let savedTemplate = response;
    try {
      savedTemplate = yield call(costFileTemplateApi.getTemplate, suvc);
    } catch (e) {
      yield put(receiveErrorInCostFileTemplate(getErrorMessage(e, UNABLE_TO_LOAD_COST_FILE_TEMPLATE)));
    }
    yield put(receiveCostFileTemplateSaveStatus(suvc, savedTemplate));
  } catch (e) {
    yield put(receiveErrorInCostFileTemplate(getErrorMessage(e, UNABLE_TO_SAVE_COST_FILE_TEMPLATE)));
  }
}

export function* deleteCostFileTemplate({ data }) {
  const { suvc, templateId } = data;
  try {
    yield call(costFileTemplateApi.deleteTemplate, templateId);
    yield put(receiveCostFileTemplateDeleteStatus(suvc));
  } catch (e) {
    yield put(receiveErrorInCostFileTemplate(getErrorMessage(e, UNABLE_TO_DELETE_COST_FILE_TEMPLATE)));
  }
}

export function* costFileTemplateSaga() {
  yield takeLatest(FETCH_COST_FILE_TEMPLATE, fetchCostFileTemplate);
  yield takeEvery(SAVE_COST_FILE_TEMPLATE, saveCostFileTemplate);
  yield takeEvery(DELETE_COST_FILE_TEMPLATE, deleteCostFileTemplate);
}
